import { NA } from "src/constants/common"
import dayjs from "dayjs"

export const formatDate = (
  value?: string | Date,
  formatString = "YYYY-MM-DD hh:mm:ss"
) => {
  if (!value) return NA
  const dateTime = typeof value === "string" ? new Date(value) : value
  return dayjs(dateTime).format(formatString)
}
